import * as React from "react";
import { isEqual } from "lodash";
import { XElementConfig } from "../../../utils/interfaces/Elements/XElement.interfaces";
import { useBreakpoint } from "../../../hooks/useBreakpoint";
import { TUseXElement, useXElement } from "../../../hooks/useXElement";
import { getValueOnBreakpoint } from "../../../lib/getValueOnBreakpoint";
import {
  IXStackProps,
  XStackProps,
} from "../../../utils/interfaces/containers/XStack.interfaces";
import XStackCore from "./core";
import { TDynamicXElement } from "../../../utils/types/core/DynamicXElement";

import XText from "../../elements/XText";
import XButton from "../../elements/XButton";
import XRating from "../../elements/XRating";
import XMap from "../../elements/XMap";
import XBreadcrumb from "../../elements/XBreadcrumb";
import XForm from "../../elements/XForm";
import XIcon from "../../elements/XIcon";
import XImage from "../../elements/XImage";

const compareProps = (prevProps: any, nextProps: any) => {
  return isEqual(prevProps, nextProps);
};

const XStackProd: React.FC<XStackProps> = React.memo(
  ({ config = {} as XElementConfig, children }) => {
    // WE TRACK THE BREAK POINTS CHANGES
    const breakpoint = useBreakpoint();

    // WE ARE GETTING THE CURRENT ELEMENT FROM THE ATOM FAMILY
    const { xElement } = useXElement<TUseXElement<IXStackProps>>(config.index);

    // GARBING THE INDEX UPDATER FOR GENERAL USAGE

    // IF WE DONT HAVE THIS ELEMENT CONFIGS ADDED WE DON'T SHOW IT
    if ((!xElement || Object.keys(xElement).length === 0) && !children) {
      return null;
    }

    // WE GET ALL DEVICES PROPS AS VALUE
    const { value } = xElement;

    // WE NOW USE THE CURRENT BREAKPOINT VALUE ON THIS ELEMENT
    const valueAtBreakPoint = getValueOnBreakpoint<IXStackProps>(
      value as any,
      breakpoint
    );

    return (
      <XStackCore
        index={config.index}
        props={valueAtBreakPoint}
        DynamicXElement={DynamicXElement}
        children={children}
      />
    );
  },
  compareProps
);

export default XStackProd;

const DynamicXElement: TDynamicXElement = React.memo(({ index, hierachy }) => {
  const { xElement: element, setXElement } =
    useXElement<TUseXElement<any>>(index);

  const xElement = element ?? {};

  React.useEffect(() => {
    setXElement({
      ...xElement,

      hierachy: hierachy + "-" + xElement.name,
    });
  }, [index]);

  switch (xElement.name) {
    case "XText":
      return <XText config={{ index }} />;

    case "XButton":
      return <XButton config={{ index }} />;

    case "XImage":
      return <XImage config={{ index }} />;

    case "XRating":
      return <XRating config={{ index }} />;

    case "XIcon":
      return <XIcon config={{ index }} />;

    case "XMap":
      return <XMap config={{ index }} />;

    case "XBreadcrumb":
      return <XBreadcrumb config={{ index }} />;

    case "XForm":
      return <XForm config={{ index }} />;

    case "XStack":
      return <XStackProd config={{ index }} />;

    default:
      return null;
  }
}, compareProps);
